import http from "@/common/http";

// 登录接口
export function login(bid, username, password, captchaUuid, captchaCode) {
  return http.post("/auth/common/user/login", {
    bid,
    username,
    password,
    uuid: captchaUuid,
    code: captchaCode,
  });
}

// 登录验证码
export function code() {
  return http.get("/code");
}

// 忘记密码页面-发送验证码
export function sendResetPwdCaptcha(params) {
  return http.post("/auth/common/user/sendCaptcha", params);
}

// 忘记密码页面，重置密码
export function resetUpdatePassword(params) {
  return http.post("/auth/common/user/updatePassword", params);
}
